export default "__VITE_ASSET__DurohEgl__"